import axios from "axios";
import moment from "moment-timezone";
import { Component, Vue, Prop } from "vue-facing-decorator";

import * as XLSX from "xlsx";
import excelServices from "../../services/excelServices";

//Columns
import { formats } from "../../services/importRules/importColumns";

//Rules
import HeaderRules from "../../services/importRules/headerRules";
import { rules } from "../../services/importRules/importRules";

import { getSiretValue } from "../../services/companyServices";

type Header = {
    title: string;
    value: string;
    sortable?: boolean;
    align?: "start" | "center" | "end";
    width?: string;
};

@Component
export class ImportDocumentBase extends Vue {
    @Prop({ type: String, required: true }) readonly documentType: string;

    ruleManager = undefined;
    formatColumns = undefined;

    fileName: string = "";
    extension: string = "";
    stream = null;
    result = { data: {}, file: {} };
    event: any;

    verifLoading: boolean = false;
    importLoading: boolean = false;

    importedItems = [];
    importedHeaders: Header[] = [];
    importedAccountingDates = [];

    wrongFormat: boolean = false;

    beforeMount() {
        this.ruleManager = new HeaderRules(rules[this.documentType].rules);
        this.formatColumns = formats[this.documentType].columns;
    }

    get existingFile() {
        if (Object.values(this.result.data).length && this.result.file["name"]) {
            return true;
        }
        return false;
    }

    resetVariables() {
        this.fileName = "";
        this.stream = [];
        this.result = { data: {}, file: {} };
    }

    onFileDeleted() {
        this.resetVariables();
    }

    async onFileChanged(e) {
        this.resetVariables();
        this.event = e;

        if (e && ((e.target && e.target.files) || e.file)) {
            let file;
            if (e.target && e.target.files) {
                file = e.target.files[0];
            } else {
                file = e.file;
            }
            // const self = this;
            this.extension = file.name.split(".").pop();
            this.fileName = "";

            if (["xlsx", "xls"].includes(this.extension)) {
                const result = await excelServices.xlsx2csv(file);
                if (result) {
                    const fileName = file.name.toString();
                    this.fileName = fileName;
                    this.result = {
                        data: result,
                        file: { name: fileName },
                    };
                }
            } else {
                const reader = new FileReader();
                reader.onload = async () => {
                    const { result } = reader;
                    if (result) {
                        const fileName = file.name.toString();
                        this.fileName = fileName;
                        this.result = {
                            data: result,
                            file: file,
                        };
                    }
                };
                reader.readAsText(file);
            }
        }
    }

    async onTestFileChanged(testFile) {
        if (testFile?.signedUrl) {
            let result;
            if (testFile.type === "XLSX" || testFile.type === "XLS") {
                result = await axios.get(testFile.signedUrl, { responseType: "arraybuffer" });
                const workbook = XLSX.read(result.data, { dateNF: "DD/MM/YYYY" });
                for (const sheetName of workbook.SheetNames) {
                    result.data = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
                    if (result.data) {
                        break;
                    }
                }
            } else {
                result = await axios.get(testFile.signedUrl, {});
            }
            if (result?.data) {
                this.result = {
                    data: result.data,
                    file: testFile,
                };
                // this.readData(result.data, testFile)
            }
            this.fileName = testFile.name + "." + testFile.type.toLowerCase();
        } else {
            this.fileName = "";
        }
    }

    checkFormat(result) {
        this.wrongFormat = true;
        if (!result) {
            return false;
        }
        if (result.startsWith("<")) {
            return false;
        }
        this.wrongFormat = false;
        return true;
    }

    getDate(date: string) {
        const dateFrPattern = /^([0-9]{1,2})[-/]([0-9]{1,2})[-/]([0-9]{4})$/;
        const dateEnPattern = /^([0-9]{4})[-/]([0-9]{1,2})[-/]([0-9]{1,2})$/;
        let result = date.match(dateFrPattern);
        if (result && result.length === 4) {
            let fdate = result[3];
            if (result[2].length === 1) {
                fdate += "0";
            }
            fdate += result[2];
            if (result[1].length === 1) {
                fdate += "0";
            }
            fdate += result[1];
            // return result[3]+result[2]+result[1]
            return fdate;
        }
        result = date.match(dateEnPattern);
        if (result && result.length === 4) {
            let fdate = result[1];
            if (result[2].length === 1) {
                fdate += "0";
            }
            fdate += result[2];
            if (result[3].length === 1) {
                fdate += "0";
            }
            fdate += result[3];
            return fdate;
        }
        return date;
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    convertDate(date: string) {
        return moment(date, [
            "DD-MM-YYYY",
            "YYYY-MM-DD",
            "DD/MM/YYYY",
            "YYYY/MM/DD",
            "MM/DD/YYYY",
        ]).format("DD-MM-YYYY");
    }

    convertAmount(amount: string) {
        return amount.toString().split(".").join(",");
    }
}
